// ============================================================
// HABIT OS — Höchstmengen für Nahrungsergänzungsmittel
//
// Einzige Quelle für die Etikett-Analyse (useAgent.js) und die
// Seite "So prüfen wir" (MethodSheet.jsx). Werte ändern nur hier,
// mit Eintrag im ÄNDERUNGSVERLAUF.
// ============================================================

export const HOECHSTMENGEN_STAND = "2. November 2026";

export const HOECHSTMENGEN_QUELLEN = [
  {
    titel: "BfR: Aktualisierte Höchstmengenvorschläge für Vitamine und Mineralstoffe in Nahrungsergänzungsmitteln und angereicherten Lebensmitteln. Stellungnahme Nr. 006/2024 vom 22.02.2024",
    url:   "https://www.bfr.bund.de/cm/343/aktualisierte-hoechstmengenvorschlaege-fuer-vitamine-und-mineralstoffe-in-nahrungsergaenzungsmitteln-und-angereicherten-lebensmitteln-2024.pdf",
  },
  {
    titel: "BfR: Aktualisierung 2024 der Höchstmengenvorschläge für Vitamin B6 in Lebensmitteln inklusive Nahrungsergänzungsmitteln",
    url:   "https://www.bfr.bund.de/cm/343/aktualisierung-2024-hoechstmengenvorschlaege-fuer-vitamin-b6-in-lebensmitteln-inklusive-nahrungsergaenzungsmitteln.pdf",
  },
  {
    titel: "BfR: Für die Anreicherung von Lebensmitteln mit Omega-3-Fettsäuren empfiehlt das BfR die Festsetzung von Höchstmengen. Stellungnahme Nr. 030/2009 vom 26.05.2009",
    url:   "https://www.bfr.bund.de/cm/343/fuer_die_anreicherung_von_lebensmitteln_mit_omega_3_fettsaeuren_empfiehlt_das_bfr_die_festsetzung_von_hoechstmengen.pdf",
  },
  {
    titel: "Verbraucherzentrale: Mikronährstoffe – Ab wann ist es zu viel? (Übersichtstabelle der BfR-Werte)",
    url:   "https://www.verbraucherzentrale.de/wissen/lebensmittel/nahrungsergaenzungsmittel/die-dosis-macht-das-gift-13392",
  },
];

// Höchstmenge pro Tagesverzehrempfehlung eines Produkts (Erwachsene)
export const HOECHSTMENGEN = [
  { stoff: "Vitamin D",       menge: "20 µg",   hinweis: "entspricht 800 IE" },
  { stoff: "Vitamin C",       menge: "250 mg" },
  { stoff: "Vitamin E",       menge: "30 mg" },
  { stoff: "Vitamin K1",      menge: "80 µg" },
  { stoff: "Vitamin K2",      menge: "25 µg" },
  { stoff: "Vitamin B6",      menge: "0,9 mg",  hinweis: "ab 15 Jahren; 2024 von 3,5 mg gesenkt" },
  { stoff: "Vitamin B12",     menge: "25 µg" },
  { stoff: "Folsäure",        menge: "200 µg" },
  { stoff: "Calcium",         menge: "500 mg" },
  { stoff: "Magnesium",       menge: "250 mg" },
  { stoff: "Zink",            menge: "6,5 mg" },
  { stoff: "Eisen",           menge: "6 mg",    hinweis: "Eisen nur nach ärztlich festgestelltem Mangel" },
  { stoff: "Selen",           menge: "40 µg" },
  { stoff: "Jod",             menge: "100 µg" },
  { stoff: "Kupfer",          menge: "1 mg" },
  { stoff: "Chrom",           menge: "60 µg" },
  { stoff: "Mangan",          menge: "0,5 mg" },
  { stoff: "Kalium",          menge: "500 mg" },
  { stoff: "EPA + DHA (Omega-3)", menge: "1 g",  hinweis: "BfR: höchstens 1,5 g pro Tag aus allen Quellen, davon etwa 1 g aus Nahrungsergänzung" },
];

export const AENDERUNGSVERLAUF = [
  {
    datum: "2. November 2026",
    text:  "Umstellung auf die BfR-Stellungnahme 006/2024. Geändert: Vitamin B6 von 3,5 mg auf 0,9 mg, Selen von 45 µg auf 40 µg, Omega-3 von 1,5 g auf 1 g aus Nahrungsergänzung. Neu: Vitamin E, K1, K2, B12, Jod, Kupfer, Chrom, Mangan, Kalium.",
  },
];

// Kompakte Zeile für den Prompt der Etikett-Analyse
export function hoechstmengenAlsPromptZeile() {
  return HOECHSTMENGEN.map(h => `${h.stoff} ${h.menge}`).join(" · ");
}
